<template>
  <div class="pipe-extraction bg-transparent rounded-2px z-99 w-full h-full pt-10px">
    <el-row :gutter="10" class="pr-5px mt-10px">
      <el-col :span="12">
        <el-input
          size="small"
          v-model="keywords"
          placeholder="请输入管线位号"
          clearable
          @clear="searchHandler"
        ></el-input>
      </el-col>
      <el-col :span="12" class="search-wrap h-36px leading-36px">
        <el-button @click="searchHandler" size="small" type="primary" class="ml-5px"
          >搜索</el-button
        >
        <span class="whitespace-nowrap text-[#fff] ml-5px text-14px">抽离</span>
        <el-switch
          class="ml-5px"
          size="small"
          v-model="allFlowStatus"
          :disabled="allFlowDisabled"
          @change="changeAllStatus"
          inactive-text-color="#fff"
          active-color="#45f2eb"
        ></el-switch>
      </el-col>
    </el-row>
    <div class="flex items-center">
      <span class="pr-20px text-[#fff] text-14px">透明度</span>
      <el-slider
        class="flex-1"
        v-model="transparency"
        @change="transChange"
        :format-tooltip="tooltipFormat"
      ></el-slider>
    </div>
    <el-table
      v-loading="tableLoading"
      ref="markerTable"
      :data="tableData"
      height="calc(100% - 122px)"
      :row-key="(row) => row.tagId"
      class="markerTable"
      :cell-style="{ 'text-align': 'center' }"
      :header-cell-style="{ 'text-align': 'center' }"
      :highlight-current-row="true"
      @selection-change="handleSelectionChange"
      @row-click="moveToPipe"
    >
      <el-table-column type="selection" width="50"></el-table-column>
      <el-table-column show-overflow-tooltip prop="Code" label="管线位号"></el-table-column>
      <el-table-column show-overflow-tooltip prop="Name" label="管线名称"></el-table-column>
      <el-table-column show-overflow-tooltip label="抽离状态">
        <template slot-scope="{ row }">
          <span
            class="inline-block w-12px h-12px rounded-1/2 bg-[#fff]"
            :class="row.status ? '!bg-[#00fbf2] box-shadow' : ''"
          ></span>
        </template>
      </el-table-column>
    </el-table>
    <el-pagination
      small
      background
      @current-change="getTableData"
      :current-page.sync="page.pageNo"
      :page-size="page.pageSize"
      layout="total, prev, pager, next"
      :total="page.total"
      :pager-count="5"
      class="flex justify-end mt-10px"
    ></el-pagination>
  </div>
</template>

<script>
import { isEmpty, findIndex, filter, map, forEach } from 'lodash'
import DiyCodeService from '../../service/DiyCodeService'

export default {
  components: {},
  props: {
    player: {
      type: Object,
      default: () => {
        return {}
      },
    },
  },
  data() {
    return {
      allFlowDisabled: true,
      allFlowStatus: false, // 批量流向动画展示
      tableLoading: false,
      treeFilterKey: null,
      curRootItem: null, // 当前根节点
      currentDeviceId: null, // 当前装置id
      currentModelId: null, // 当前的模型id
      transparency: (60 / 255) * 100,
      page: {
        pageNo: 1,
        pageSize: 15,
        total: 0,
      },
      keywords: '',
      tableData: [],
      currentShowPipes: [], // 当前已经创建的动画
      currentSelectedPipe: [], // 表格多选
    }
  },
  computed: {
    // 可视化头部组件
    pipeTableName() {
      return (
        _.get(Wiz, 'globalSettings.dynamicModules.modules["visualization-cockpit-tongre"].config')
          ?.pipeTableName || 'diy_pipeline_management'
      )
    },
  },
  watch: {},
  async created() {
    this.searchHandler()
  },
  async beforeDestroy() {
    // 获取根节点
    const rootInfo = await this.player.Native.ModelTree.getRootItems()
    if (rootInfo?.length && rootInfo[0].item) {
      // 恢复模型状态
      await this.player.Native.ModelTree.setItemAlpha(rootInfo[0].item, 255)
    }
  },
  methods: {
    // 装置树检索
    filterTreeNode(value, data) {
      if (!value) return true
      return data.deviceName.indexOf(value) !== -1
    },
    // 透明度修改
    async transChange(val) {
      if (this.currentShowPipes.length) {
        try {
          // 获取根节点
          const rootInfo = await this.player.Native.ModelTree.getRootItems()
          if (rootInfo?.length && rootInfo[0].item) {
            // 恢复模型状态
            await this.player.Native.ModelTree.setItemAlpha(
              rootInfo[0].item,
              Math.round((this.transparency / 100) * 255)
            )
          }
          const params = _.map(this.currentShowPipes, (item) => {
            return {
              item: item.item,
              alpha: 255,
            }
          })
          this.player.Native.ModelTree.batchSetItemAlpha(params)
        } catch (error) {
          console.error('---> error', error)
        }
      }
    },
    // 滑块format
    tooltipFormat(val) {
      return (val / 100).toFixed(1)
    },
    // 重置数据
    async resetData() {
      this.currentShowPipes = [] // 清空动画列表
      this.currentSelectedPipe = [] // 清空多选
      this.tableData = [] // 清空表单
    },
    // 监听模型切换加载完成操作
    checkModelLoadEnd(value, handle, name) {
      // this.initDevice()
      this.player.Native.Model.EventProgressEnd.disconnect(this.checkModelLoadEnd)
    },
    // 表格多选
    handleSelectionChange(val) {
      this.currentSelectedPipe = val
      this.resetSwitchStatus()
    },
    // 初始化装置状态
    async initDevice() {
      const rootInfo = await this.player.Native.ModelTree.getRootItems()
      if (rootInfo?.length && rootInfo[0].item) {
        this.curRootItem = rootInfo[0].item
        await this.player.Native.ModelTree.setItemAlpha(
          rootInfo[0].item,
          Math.round((this.transparency / 100) * 255)
        )
      }
    },
    // 全量修改抽离状态
    async changeAllStatus() {
      if (this.allFlowStatus) {
        if (_.isEmpty(this.currentShowPipes)) {
          await this.initDevice()
        }
        // 打开
        try {
          this.player.Native.Camera.moveToCode(this.currentSelectedPipe[0].Code, 2)
          const needOpenPipes = filter(this.currentSelectedPipe, ['status', false])
          if (needOpenPipes?.length) {
            const itemInfoPromises = map(needOpenPipes, (pipe) => {
              return this.player.Native.ModelTree.findItemByCode(pipe.Code, this.curRootItem)
            })
            const itemInfoRes = await Promise.all(itemInfoPromises)
            const itemList = map(itemInfoRes, (it) => {
              return {
                item: it.item,
                alpha: 255,
              }
            })
            await this.player.Native.ModelTree.batchSetItemAlpha(itemList)
            for (let j = 0; j < needOpenPipes.length; j += 1) {
              this.currentShowPipes.push({
                code: needOpenPipes[j].Code,
                item: itemInfoRes[j].item,
              })
            }
            // 同步更新对应操作列开关状态
            const codeList = map(needOpenPipes, 'Code')
            forEach(this.tableData, (item) => {
              if (codeList.includes(item.Code)) {
                item.status = true
              }
            })
          }
        } catch (error) {
          console.error(`管线抽离出错了  ${error}`)
        }
      } else {
        const needClosePipes = filter(this.currentSelectedPipe, ['status', true])
        const needCloseItem = []
        for (let i = 0; i < needClosePipes.length; i += 1) {
          const showIndex = findIndex(this.currentShowPipes, ['code', needClosePipes[i].Code])
          if (showIndex > -1) {
            needCloseItem.push({
              item: this.currentShowPipes[showIndex].item,
              alpha: 60,
            })
          }
        }
        await this.player.Native.ModelTree.batchSetItemAlpha(needCloseItem)
        const closedCodes = map(needClosePipes, 'Code')
        this.currentShowPipes = filter(this.currentShowPipes, (item) => {
          return !closedCodes.includes(item.code)
        })
        if (_.isEmpty(this.currentShowPipes)) {
          this.resetDevice()
        }
        // 更新表中开关状态
        forEach(this.tableData, (item) => {
          if (closedCodes.includes(item.Code)) {
            item.status = false
          }
        })
      }
    },
    // 获取管线表数据
    async getTableData() {
      this.tableLoading = true
      const data = {
        TableName: this.pipeTableName || 'diy_pipeline_management',
        _PageIndex: this.page.pageNo,
        _PageSize: this.page.pageSize,
      }
      if (this.keywords) {
        data._Where = [
          {
            Name: 'Code',
            Type: 'Like',
            Value: this.keywords,
          },
        ]
      }
      const [err, res] = await DiyCodeService.getPipesData(data)
      this.tableLoading = false
      if (!err && res && res.Data) {
        this.tableData = res.Data
        this.page.total = res.DataCount
      }
      forEach(this.tableData, (item) => {
        const index = findIndex(this.currentShowPipes, ['code', item.Code])
        if (index > -1) {
          this.$set(item, 'status', true)
        } else {
          this.$set(item, 'status', false)
        }
      })
    },
    // 重置装置透明度
    async resetDevice() {
      const rootInfo = await this.player.Native.ModelTree.getRootItems()
      if (rootInfo?.length && rootInfo[0].item) {
        await this.player.Native.ModelTree.setItemAlpha(rootInfo[0].item, 255)
      }
    },
    // 当单个管线的按钮状态切换时，调整总体抽离开关状态
    resetSwitchStatus() {
      if (this.currentSelectedPipe?.length) {
        this.allFlowDisabled = false
        const codeWithAnimation = map(this.currentShowPipes, (item) => {
          return item.code
        })
        let hasNoAnimationPipe = false
        // 判断多选项里是否有还未加载动画的管线
        try {
          forEach(this.currentSelectedPipe, (item) => {
            if (!codeWithAnimation.includes(item.Code)) {
              hasNoAnimationPipe = true
              throw new Error()
            }
          })
          // eslint-disable-next-line no-empty
        } catch (e) {}
        if (hasNoAnimationPipe) {
          // 有未打开抽离的管线、将状态改为false
          this.allFlowStatus = false
        } else {
          // 无未打开的抽离，则按钮为true，可执行关闭操作
          this.allFlowStatus = true
        }
      } else {
        this.allFlowDisabled = true
      }
    },
    // 搜索
    searchHandler() {
      this.page.pageNo = 1
      this.getTableData()
    },
    moveToPipe(row) {
      if (row.Code) {
        this.player.Native.Camera.moveToCode(row.Code, 2)
      }
    },
  },
}
</script>
<style lang="scss">
.visualization-select-popper {
  .el-select-dropdown__list {
    padding: 5px !important;
  }
}
</style>
<style lang="scss" scoped>
.search-wrap {
  ::v-deep .el-button {
    height: 28px !important;
    line-height: 28px !important;
    border-radius: 5px !important;
  }
}
.markerTable {
  ::v-deep .el-checkbox {
    margin: 0 !important;
  }
  ::v-deep .el-table th.is-leaf,
  .el-table td {
    border: none !important;
  }
}
::v-deep.device-tree {
  overflow-y: auto;
  height: 100%;
  color: #fff;
  background-color: transparent !important;

  .el-tree-node__content:hover {
    background: #0499a744 !important;
  }

  .el-tree-node.is-current > .el-tree-node__content {
    background: #049aa780 !important;
  }

  .el-tree-node:focus > .el-tree-node__content {
    background: #049aa780 !important;
  }
  .el-tree-node__label {
    color: #fff !important;
  }

  .custom-tree-node {
    width: 100%;
    font-size: 14px;
  }
}
.pipe-extraction {
  ::v-deep .el-slider__bar {
    background: #11939d !important;
  }
  ::v-deep .el-slider__button {
    width: 10px !important;
    height: 10px !important;
    border: 2px solid #11939d !important;
  }
}
::v-deep {
  .el-pagination.is-background.el-pagination--small .btn-next,
  .el-pagination.is-background.el-pagination--small .btn-prev,
  .el-pagination.is-background.el-pagination--small .el-pager li {
    padding: 0 !important;
    margin: 0 3px !important;
  }
}
.box-shadow {
  box-shadow: 0 0 8px #00fbf2;
}
</style>
